<article class="ProviderSearch">
  @if (!selectedResult) {
    <article class="ProviderSearchContent u-flex">
      @if (showFiltersMembersAside) {
        <aside class="ProviderSearchAside ProviderSearchAside--Desktop">
          @if (asideHeaderConfig.showAsideHeader) {
            <header class="ProviderSearchAside__Header">
              <h4
                class="ProviderSearchAside__HeaderTitle t-bold"
                [innerHTML]="asideHeaderConfig.header"
                -
                data-test-id="providerSearchAsideHeader"
              ></h4>
              <span
                class="ProviderSearchAside__HeaderSubTitle t-data"
                [innerHTML]="asideHeaderConfig.subHeader"
                data-test-id="providerSearchAsideSubHeader"
              ></span>
            </header>
          }
          @for (member of members; track member; let i = $index) {
            <section
              class="ProviderSearchAside__Section u-flex"
              (click)="selectConsumer(members, i)"
              [ngClass]="{
                SelectPCP: member.isMemberSelected,
                PCPSelected: member.isPCPSelected,
              }"
            >
              <div class="ConsumerInfo u-flex">
                <div class="u-flex">
                  <div class="BulletContainer">
                    @if (member.isMemberSelected && !member.isPCPSelected) {
                      <span
                        class="NumberedBullet--Active"
                        [data-test-id]="'selectedMember_' + i"
                        [innerHTML]="i + 1"
                      ></span>
                    }
                    @if (!member.isPCPSelected && !member.isMemberSelected) {
                      <span
                        class="NumberedBullet--Inactive"
                        [data-test-id]="'unSelectedMember_' + i"
                        [innerHTML]="i + 1"
                      ></span>
                    }
                    @if (member.isPCPSelected) {
                      <i
                        [data-test-id]="'pcpSelectedIcon_' + i"
                        class="icon icon--medium"
                        >check_circle</i
                      >
                    }
                  </div>
                  <div class="ConsumerContainer">
                    <div class="u-flex PersonalDetails">
                      <h6
                        class="SubscriberName t-bold"
                        [data-test-id]="'personalDetails_Name_' + i"
                        [innerHTML]="getMemberName(member)"
                      ></h6>
                      <span
                        class="SubscriberDOB t-data"
                        [data-test-id]="'personalDetails_DOB_' + i"
                        [innerHTML]="member.date_of_birth | date: 'MM/dd/yyyy'"
                      ></span>
                    </div>
                  </div>
                </div>
                <div class="ProviderDetails">
                  @if (!member.isPCPSelected) {
                    <p
                      class="ProviderDetails__Name"
                      [data-test-id]="'providerDetails_Name_' + i"
                      [innerHTML]="getProviderDetail(member)"
                    ></p>
                  }
                  @if (member.isPCPSelected) {
                    <div class="SelectedProviderContainer">
                      <div class="SelectedProviderDetails">
                        <span
                          class="SelectedProviderDetails__Name t-bold"
                          [data-test-id]="'selectedProviderDetails_Name_' + i"
                          [innerHTML]="selectedProviderName(member)"
                        ></span>
                        <span
                          [data-test-id]="'selectedProvider_Specialty_' + i"
                          class="SelectedProviderDetails__PrimarySpecialty t-data"
                          [innerHTML]="
                            member.selectedProvider.primary_specialty
                          "
                        ></span>
                      </div>
                      <icon
                        name="delete"
                        (click)="removePCP(member)"
                        [data-test-id]="'deleteSelectedProviderIcon_' + i"
                        class="SelectedProviderDetails__DeleteIcon"
                      ></icon>
                    </div>
                  }
                </div>
              </div>
              @if (!member.isPCPSelected) {
                <i
                  class="icon icon--medium icon--pointer"
                  [data-test-id]="'selectedProviderDetailViewIcon_' + i"
                >
                  chevron_right
                </i>
              }
            </section>
          }
        </aside>
      } @else {
        <ng-template [ngTemplateOutlet]="filters"></ng-template>
      }
      @if (showFiltersAside) {
        <aside
          class="ProviderSearchFilters ProviderSearchFilters--Desktop"
          #filters
        >
          <header class="ProviderSearchFilters__Header">
            <h6
              class="ProviderSearchFilters__HeaderText t-bold"
              data-test-id="providerSearchFiltersHeader"
              [innerHTML]="'Filter Results'"
            ></h6>
            @if (showFiltersClose) {
              <zip-button
                [config]="{ level: 'text', icon: 'close' }"
                (zipButtonClicked)="toggleFilters()"
                data-test-id="closeProviderSearchFilterButton"
              ></zip-button>
            }
          </header>
          <main class="ProviderSearchFilters__Body">
            @for (group of config.filters.groups; track group) {
              <section class="ProviderSearchFilters__Section">
                @if (group.header) {
                  <header class="ProviderSearchFilters__SectionHeader">
                    <p
                      class="t-data t-bold t-caps"
                      data-test-id="providerSearchFiltersGroupHeader"
                      [innerHTML]="group.header"
                    ></p>
                  </header>
                }
                @for (
                  control of group.controls;
                  track control;
                  let i = $index
                ) {
                  <form-control
                    [config]="control"
                    [group]="filtersForm"
                    [control]="filtersForm.get(control.prop)"
                    [data-test-id]="'providerSearchFiltersGroupControl' + i"
                  >
                  </form-control>
                }
              </section>
            }
          </main>
          <div class="ProviderSearchFilters__Footer u-flex u-justifyBetween">
            <zip-button
              level="medium"
              content="Clear Filters"
              data-test-id="closeProviderSearchFilters"
              (zipButtonClicked)="handleFilters('clear')"
            >
            </zip-button>
            <zip-button
              level="high"
              content="Filter"
              data-test-id="applyProviderSearchFilters"
              (zipButtonClicked)="handleFilters('apply')"
            >
            </zip-button>
          </div>
        </aside>
      }
      <!-- Main body -->
      <main class="ProviderSearch__Main layout--detail__main">
        @if (showFiltersMembersAside) {
          <zip-button
            class="ProviderSearch__MainAside--Mobile"
            data-test-id="providerSearchMobileShowPCPButton"
            [config]="{ level: 'text', content: 'Show PCP', icon: 'tune' }"
            (zipButtonClicked)="showPCPModal = true"
          >
          </zip-button>
        }
        @if (showFiltersAside || !showFiltersMembersAside) {
          <zip-button
            class="ProviderSearch__MainFilters--Mobile"
            [config]="{
              level: 'text',
              content: 'Filter Results',
              icon: 'tune',
            }"
            data-test-id="providerSearchMobileShowFiltersModal"
            (zipButtonClicked)="showFilters = true; showFiltersModal = true"
          >
          </zip-button>
        }
        <section class="ProviderSearch__Container">
          <div class="ProviderSearch__MainBanner">
            <search-bar
              [initialZipcode]="zipcode"
              [config]="searchBarConfig"
              [initialPCCDistance]="distance"
              (initialDistance)="distance = $event"
              (distanceChanged)="updateDistance($event)"
              (search)="updateZipcodeSearch($event)"
              (nameSearch)="searchByName($event)"
            >
            </search-bar>
          </div>
          <div class="u-flex u-relative">
            <main
              #scrollToSearchResults
              class="ProviderSearch__MainContent"
              [zipBusy]="busy"
            >
              <header class="ProviderSearch__MainHeader">
                @if (showFiltersMembersAside) {
                  <zip-button
                    data-test-id="providerSearchFilterResultsButton"
                    [config]="{ level: 'high', content: 'Filter Results' }"
                    (zipButtonClicked)="toggleFilters()"
                  ></zip-button>
                }
              </header>
              @if (backendResults.length > 0) {
                @if (
                  showFiltersMembersAside &&
                  this.whichWorkflow === 'doctorSearch'
                ) {
                  <p
                    data-test-id="providerSearchFoundMsg"
                    [innerHTML]="doctorsFoundMessage()"
                  ></p>
                }
                <section class="SearchResults">
                  @for (
                    thisResult of backendResults;
                    track thisResult;
                    let i = $index
                  ) {
                    <provider-card
                      [result]="thisResult"
                      [index]="i"
                      [resultIsSelected]="resultIsSelected"
                      [selectedProviders]="selectedProviders"
                      [currentMember]="currentMember"
                      [removePCPavatar]="removePCPavatar"
                      [config]="config.providerCardConfig"
                      [whichWorkflow]="whichWorkflow"
                      (viewProfile)="
                        !config.disableViewProfile
                          ? viewSelectedProfile($event)
                          : null
                      "
                      (addResultChange)="addResult($event)"
                      (removeResultChange)="removeResult($event)"
                    >
                    </provider-card>
                  }
                </section>
                <paginator
                  class="ProviderCardPaginator"
                  [config]="paginatorConfig"
                  [data]="backendResults"
                  (pageSelected)="goToPage($event)"
                >
                </paginator>
              } @else {
                @if (!isAPILoading && backendResults.length === 0) {
                  <div class="ProviderSearchError">
                    <error-empty
                      [config]="{
                        title: config?.noResultsConfig?.header
                          ? config.noResultsConfig.header
                          : 'No Physicians Identified with Current Search Criteria.',
                        image_url:
                          config?.noResultsConfig?.img ||
                          'https://d32ul9oyxvd2n5.cloudfront.net/illustrations/empty-4.svg',
                      }"
                    >
                    </error-empty>
                  </div>
                }
              }
            </main>
          </div>
        </section>
      </main>
      <footer class="ProviderSearch__Footer">
        <div class="ProviderSearch__Footer--Desktop">
          <zip-button
            data-test-id="providerSearchDesktopBackButton"
            [config]="buttonConfig?.back || defaultFooterButtons.back"
            (zipButtonClicked)="goToPrevious()"
          >
          </zip-button>
          <div class="ProviderSearch__FooterButtons">
            <zip-button
              [config]="buttonConfig?.skip || defaultFooterButtons.skip"
              data-test-id="providerSearchDesktopSkipButton"
              [disabled]="!isPcpNotSelected"
              (zipButtonClicked)="onSkip()"
            >
            </zip-button>
            @if (buttonConfig?.save) {
              <zip-button
                data-test-id="providerSearchDesktopSaveButton"
                [config]="buttonConfig?.save || defaultFooterButtons.save"
                (zipButtonClicked)="saveAndExitStep()"
              >
              </zip-button>
            }
            <zip-button
              [config]="buttonConfig?.continue || defaultFooterButtons.continue"
              data-test-id="providerSearchDesktopContinueButton"
              [disabled]="isPcpNotSelected"
              (zipButtonClicked)="submit()"
            >
            </zip-button>
          </div>
        </div>
        <div class="ProviderSearch__Footer--Mobile">
          <zip-button
            [level]="buttonConfig?.back?.level || 'medium'"
            [icon]="buttonConfig?.back?.icon || 'chevron_left'"
            data-test-id="providerSearchMobileBackButton"
            (zipButtonClicked)="goToPrevious()"
          >
          </zip-button>
          <zip-button
            [config]="buttonConfig?.skip || defaultFooterButtons.skip"
            [disabled]="!isPcpNotSelected"
            data-test-id="providerSearchMobileDefaultButton"
            (zipButtonClicked)="onSkip()"
          >
          </zip-button>
          @if (buttonConfig?.save) {
            <zip-button
              [level]="buttonConfig?.save?.level || 'medium'"
              [content]="buttonConfig?.save?.content || 'Save & Exit'"
              data-test-id="providerSearchMobileSaveButton"
              (zipButtonClicked)="saveAndExitStep()"
            >
            </zip-button>
          }
          <zip-button
            [level]="buttonConfig?.continue?.level || 'high'"
            [icon]="buttonConfig?.continue?.icon || 'chevron_right'"
            data-test-id="providerSearchMobileContinueButton"
            [disabled]="isPcpNotSelected"
            (zipButtonClicked)="submit()"
          >
          </zip-button>
        </div>
      </footer>
    </article>
  } @else {
    <provider-profile
      [resultIsSelected]="resultIsSelected"
      [selectedResult]="selectedResult"
      [selectedResultIdx]="selectedResultIdx"
      [backendResults]="backendResults"
      [showDetails]="showDetails"
      [contactConfigs]="contactConfigs"
      [profileConfigs]="profileConfigs"
      [educationAndTrainingConfigs]="educationAndTrainingConfigs"
      [pins]="pins"
      [busy]="busy"
      [removePCPavatar]="removePCPavatar"
      (viewAllResultsChange)="viewAllResults()"
      (previousNextChange)="selectResult($event)"
      (addProviderChange)="addResult($event)"
      (removeProviderChange)="removeResult($event)"
      (pinSelect)="selectPin($event)"
    >
    </provider-profile>
  }
</article>

<provider-search-modals
  [showPCPModal]="showPCPModal"
  [showFiltersModal]="showFiltersModal"
  [whichWorkflow]="whichWorkflow"
  [pcpModalConfig]="pcpModalConfig"
  [filtersModalConfig]="filtersModalConfig"
  [asideHeaderConfig]="asideHeaderConfig"
  [filterGroupConfig]="config.filters.groups"
  [members]="members"
  [filtersForm]="filtersForm"
  (togglePCPModal)="showPCPModal = false"
  (toggleFiltersModal)="toggleFilters()"
  (filter)="handleFilters('apply')"
  (reset)="handleFilters('clear')"
  (select)="selectedConsumer($event)"
  (removeMemberPCP)="removePCP($event)"
>
</provider-search-modals>
